<div class="footer-callto-action-area bg-light-1 mt--100">
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <div class="call-to-sction bg_image shape-move">
          <h2 class="title">Comece a estudar agora e pague apenas em Junho</h2>
          <a
            href="https://matricula.virtualfacint.com.br"
            class="rts-btn btn-primary-white with-arrow"
            >Inscreva-se<i class="fa-solid fa-arrow-right"></i
          ></a>
          <div class="cta-image">
            <img
              src="https://faculdadefacint-2bd7c.web.app/assets/images/cta/women.png"
              alt=""
            />
          </div>
          <div class="shape-image">
            <div class="shape one" data-speed="0.04">
              <img src="assets/images/cta/03.svg" alt="" />
            </div>
            <div class="shape two" data-speed="0.04">
              <img src="assets/images/cta/04.svg" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="row ptb--100">
      <div class="col-lg-12">
        <div class="footer-one-main-wrapper">
          <div class="footer-singl-wized left-logo">
            <div class="head">
              <img
                src="https://faculdadefacint-2bd7c.web.app/assets/images/logo/logo-1.png"
                alt="logo"
                loading="lazy"
              />
            </div>
            <div class="body">
              <ul class="wrapper-list">
                <li>
                  <i class="fa-solid fa-location-dot"></i
                  ><a href="https://maps.app.goo.gl/DgC6nydmA7XQ6ktG6"
                    >Av. João Paulino Vieira Filho, 870, Primeiro andar, Sala 11
                    a 14 - Centro, Maringá/PR, 87020-015</a
                  >
                </li>
                <li>
                  <i class="fa-solid fa-phone"></i
                  ><a href="tel:+5544984641888">+55 (44) 98464-1888</a>
                </li>
              </ul>
            </div>
          </div>

          <div class="footer-singl-wized">
            <div class="head">
              <h6 class="title">A Facint</h6>
            </div>
            <div class="body">
              <ul class="menu">
                <li><a [routerLink]="['/a-facint']">Sobre a Facint</a></li>
                <li><a [routerLink]="['/sede']">Unidade Sede</a></li>
                <li><a [routerLink]="['/polos']">Polos de Apoio Presencial</a></li>
                <li><a [routerLink]="['/infraestrutura']">Infraestrutura</a></li>
                <li><a [routerLink]="['/corpo-docente']">Corpo Docente</a></li>
                <li><a href="#">Calendário Escolar</a></li>
                <li><a href="#">Organograma da Faculdade</a></li>
              </ul>
            </div>
          </div>

          <div class="footer-singl-wized">
            <div class="head">
              <h6 class="title">Ajuda</h6>
            </div>
            <div class="body">
              <ul class="menu">
                <li>
                  <a
                    href="https://wa.me/5544984641888?text=Olá!%20Acessei%20o%20site%20e%20gostaria%20de%20mais%20informações."
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Fale com a gente
                  </a>
                </li>
                <li>
                  <a
                    href="mailto:ouvidoria@faculdadevincit.edu.br?subject=Contato%20via%20site&body=Olá,%20gostaria%20de%20falar%20com%20a%20ouvidoria."
                  >
                    Ouvidoria
                  </a>
                </li>
                <li><a href="#">Política de Privacidade</a></li>
                <li>
                  <a
                    href="https://portal.virtualfacint.com.br/validar-documento"
                    >Validar Documento</a
                  >
                </li>
              </ul>
            </div>
          </div>

          <div class="footer-singl-wized input-area">
            <div class="head">
              <h6 class="title">Instituição</h6>
            </div>
            <div class="body">
              <p class="disc">
                Consulte aqui o cadastro da instituição no Sistema e-MEC
              </p>

              <div class="newsletter-image" style="margin-bottom: 10px">
                <img
                  src="https://faculdadefacint-2bd7c.web.app/assets/images/banner_emec.png"
                  alt="QR Code"
                  style="display: block; max-width: 100%; height: auto"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="copyright-area-one-border">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="copyright-area-one">
            <p>
              Copyright © 2025 | Este website foi desenvolvido por
              <a href="https://ricardofranca.me">Ricardo França</a>
            </p>
            <div class="social-copyright">
              <ul>
                <li>
                  <a href="https://www.facebook.com/faculdade.facint"
                    ><i class="fa-brands fa-facebook-f"></i
                  ></a>
                </li>
                <li>
                  <a href="https://www.instagram.com/faculdade_facint"
                    ><i class="fa-brands fa-instagram"></i
                  ></a>
                </li>
                <li>
                  <a href="https://www.linkedin.com/school/faculdadefacint"
                    ><i class="fa-brands fa-linkedin"></i
                  ></a>
                </li>
                <li>
                  <a href="https://x.com/FaculdadeFacint"
                    ><i class="fa-brands fa-twitter"></i
                  ></a>
                </li>
                <li>
                  <a href="https://www.youtube.com/c/FaculdadeVINCIT"
                    ><i class="fa-brands fa-youtube"></i
                  ></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
